// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"yU-z","inlineTitle":"zU-z","sponsoredAdsWrapper":"AU-z","marketplaceRecosWrapper":"BU-z"};